import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link } from '@material-ui/core';

const content = {
  polski: {
    title: 'Nie ma takiej strony',
    text: 'Adres, który wpisałeś, nie istnieje albo został zmieniony.',
    link: 'Przejdź na stronę główną',
  },
  english: {
    title: 'Page not found',
    text: 'The address you entered does not exist or has been changed.',
    link: 'Go to the home page',
  },
};

function NotFound({ language }) {
  const text = content[language] || content.polski;
  return (
    <>
      <Typography variant="h5">{text.title}</Typography>
      <Typography variant="body2">{text.text}</Typography>
      <Typography variant="body2">
        <Link href="/">{text.link}</Link>
      </Typography>
    </>
  );
}

NotFound.propTypes = {
  language: PropTypes.string,
};

NotFound.defaultProps = {
  language: 'polski',
};

export default NotFound;
